'use strict';

(function () {

  var module = angular.module('client.components');

  controller.$inject = ['ActiveMode', '$log', 'reportToCSV', 'ReportingSchoolYearsService'];

  function controller(ActiveMode, $log, reportToCSV, ReportingSchoolYearsService) {
    var ctrl = this;
    ctrl.inited = false;
    ctrl.loadingData = false;
    ctrl.report = null;
    ctrl.reportingTeachers = [];
    ctrl.filteredReportingTeachers = [];
    ctrl.studentsTested = 0;
    ctrl.avgPreTestScore = '0%';
    ctrl.avgPostTestScore = '0%';
    ctrl.pointsAvgGrowth = 0;
    ctrl.filterYears = ReportingSchoolYearsService.get();
    ctrl.year = null;
    ctrl.filterYear = null;
    ctrl.includeArchived = false;
    let latestReportRequestId = 0;
    let pendingReportRequest = null;

    function getFilter() {
      return {
        year: ctrl.year,
        include_archived: ctrl.includeArchived,
      };
    }

    function initReportingYear() {
      ctrl.filterYear = ctrl.filterYears[0];
      ctrl.year = ctrl.filterYear.value;
      ctrl.includeArchived = ctrl.filterYear.archived === true;
    }

    ctrl.toggleYear = function toggleYear(selection) {
      ctrl.year = selection.value;
      ctrl.filterYear = selection;
      ctrl.includeArchived = selection.archived === true;
      return fetchAndUpdateReport();
    };

    function exportColumns() {
      return [
        { name: 'Year', field: 'year', wrap: true },
        { name: 'District', field: 'district', wrap: true },
        { name: 'Campus', field: 'school', wrap: true },
        { name: 'Teacher Name', field: 'teacher', wrap: true },
        { name: 'Teacher Email', field: 'teacher_email', wrap: true },
        { name: 'Course', field: 'course', wrap: true },
        { name: 'Class Name', field: 'class', wrap: true },
        { name: 'Student Name', field: 'student_name', wrap: true },
        { name: 'Student Email', field: 'student_email', wrap: true },
        { name: 'LMS ID', field: 'student_lmsid', wrap: true },
        { name: 'Pre Test Score', field: 'pretest_score', wrap: true },
        { name: 'Pre Test Date', field: 'pretest_date', wrap: true },
        { name: 'Post Test Score', field: 'posttest_score', wrap: true },
        { name: 'Post Test Date', field: 'posttest_date', wrap: true },
      ];
    }

    function formatUSDate(value) {
      if (!value) {
        return '';
      }
      var parsedDate = window.moment(value);
      if (!parsedDate.isValid()) {
        return '';
      }
      return parsedDate.format('M/D/YYYY');
    }

    function exportData() {
      if (!ctrl.report || !ctrl.report.data || !Array.isArray(ctrl.report.data.students)) {
        return [];
      }
      return ctrl.report.data.students.map(function(student) {
        var sanitizedStudent = {};
        Object.keys(student).forEach(function(key) {
          sanitizedStudent[key] = student[key] == null ? '' : student[key];
        });
        return Object.assign({}, sanitizedStudent, {
          pretest_date: formatUSDate(student.pretest_date),
          posttest_date: formatUSDate(student.posttest_date),
        });
      });
    }

    function exportFile() {
      return (ctrl.parent.title || 'TIA Scores Report') + '.csv';
    }

    ctrl.downloadCSV = function downloadCSV() {
      return ctrl.exportCSV();
    };

    ctrl.exportCSV = reportToCSV(
      function() { return exportColumns(); },
      function() { return exportData(); },
      function() { return exportFile(); },
      ','
    );

    ctrl.onExpandSchool = function onExpandSchool(school, expand) {
      ctrl.filteredReportingTeachers.forEach(function(row) {
        if (school.schoolId === row.schoolId) {
          if (row.isSchool) {
            row.isExpanded = expand;
          } else {
            row.isVisible = expand;
          }
        }
      });
    };

    function fetchAndUpdateReport() {
      const reportRequestId = ++latestReportRequestId;
      if (pendingReportRequest && typeof pendingReportRequest.cancel === 'function') {
        pendingReportRequest.cancel();
      }
      ctrl.reportingTeachers = [];
      ctrl.filteredReportingTeachers = [];
      ctrl.loadingData = true;
      const reportRequest = ActiveMode.getReportData(getFilter());
      pendingReportRequest = reportRequest;
      return reportRequest.then(function(report) {
        if (reportRequestId !== latestReportRequestId) {
          return;
        }
        pendingReportRequest = null;
        const reportData = report && report.data ? report.data : {};
        const schools = Array.isArray(reportData.schools) ? reportData.schools : [];
        const teachers = Array.isArray(reportData.teachers) ? reportData.teachers : [];
        const percentDisplay = function(value) {
          return value == null ? '0%' : value + '%';
        };

        ctrl.report = report;
        ctrl.parent.title = report && report.name ? report.name : 'TIA Scores Report';
        ctrl.studentsTested = reportData.students_tested == null ? 0 : reportData.students_tested;
        ctrl.avgPreTestScore = percentDisplay(reportData.average_pretest_score);
        ctrl.avgPostTestScore = percentDisplay(reportData.average_posttest_score);
        ctrl.pointsAvgGrowth = reportData.posttest_increase == null ? 0 : reportData.posttest_increase;

        schools.forEach(function(school, schoolIndex) {
          const schoolTeachers = teachers.filter(function(teacher) {
            return teacher.teacher_school_id == school.school_id;
          });

          ctrl.reportingTeachers.push({
            schoolId: school.school_id,
            name: school.school_name,
            schoolName: school.school_name,
            course_name: school.course_name,
            courseName: school.course_name,
            students_tested: school.students_tested,
            studentsTested: school.students_tested,
            average_pretest_score: school.average_pretest_score,
            avgPreTestScore: school.average_pretest_score,
            average_posttest_score: school.average_posttest_score,
            avgPostTestScore: school.average_posttest_score,
            posttest_increase: school.posttest_increase,
            avgPointGrowth: school.posttest_increase,
            isSchool: true,
            isExpanded: schoolIndex === 0,
            isVisible: true,
          });

          let index = 1;
          schoolTeachers.forEach(function(teacher) {
            ctrl.reportingTeachers.push({
              schoolId: school.school_id,
              name: teacher.teacher_first_name + ' ' + teacher.teacher_last_name,
              schoolName: school.school_name,
              course_name: teacher.course_name,
              courseName: teacher.course_name,
              students_tested: teacher.students_tested,
              studentsTested: teacher.students_tested,
              average_pretest_score: teacher.average_pretest_score,
              avgPreTestScore: teacher.average_pretest_score,
              average_posttest_score: teacher.average_posttest_score,
              avgPostTestScore: teacher.average_posttest_score,
              posttest_increase: teacher.posttest_increase,
              avgPointGrowth: teacher.posttest_increase,
              isSchool: false,
              isOdd: index % 2,
              isVisible: schoolIndex === 0,
            });
            index = index + 1;
          });
        });

        ctrl.filteredReportingTeachers = ctrl.reportingTeachers;
        ctrl.loadingData = false;
        return report;
      })
      .catch(function(error) {
        if (reportRequestId !== latestReportRequestId) {
          return;
        }
        pendingReportRequest = null;
        $log.error('error in fetching report:', error);
        ctrl.loadingData = false;
      });
    }

    ReportingSchoolYearsService.ready().then(function () {
      initReportingYear();
      return fetchAndUpdateReport();
    })
    .catch(function(error) {
      $log.error("error in updating report:", error);
    })
    .finally(function () {
      ctrl.inited = true;
    });
  }

  module.component('districtTiaScores', {
    require: { parent: '^^xpReport' },
    template: require('./districtTIAScores.jade'),
    controller: controller,
  });

})();
